<div class="sidebar included">
	<app-sidebar-header [title]="'Shopping basket'">
		<div actions></div>
	</app-sidebar-header>

	<div #sidebar__body class="sidebar__body sl--scrollable">
		<div class="sidebar-flight-extras">
			<ul class="body" role="list">
				<li role="listitem" *ngFor="let a of ancillaries; let i = index"
					class="extras-feature extras-feature__checkout">
					<app-svg [ngClass]="['extras-feature__icon']" svg="icons.svg#{{a.icon || 'general--plus'}}" aria-hidden="true"
						[alt]="a.name + ' icon'"></app-svg>
					<div class="extras-feature__label">
						<a class="link" (click)="openSidebar(a.link, a.flight.id)" href="javascript:;" role="button">{{a.quantity}}x
							{{a.name}}</a>
						<span class="destination">{{a.destination}}</span>
						<p class="subtext">You have 2h 45min to pay this extra. Then, this will be automatically cancelled.</p>
					</div>
					<span class="price"><span class="line-through" *ngIf="TAP_hasDiscount(a)">{{ a.cost }}
							{{ currency.symbol }}</span>
						{{TAP_printValue(a)}}</span>
					<app-svg (click)="handleRemoveClick(a, i)" title="Remove" class="remove__itemBasket"
						*ngIf="isRemovingLoading === null || isRemovingLoading !== i" [attr.aria-label]="'Remove ' + a.name"
						svg="icons.svg#general--close" [alt]="'Remove icon'"></app-svg>
					<app-loading-circle class="remove__itemLoading" *ngIf="isRemovingLoading === i"></app-loading-circle>
				</li>
			</ul>
		</div>
		<div class="sidebar-flight-extras">
			<ul role="list" class="body">
				<li role="listitem" class="extras-feature">
					<div class="extras-feature__label">
						<h3><strong>Total for all passengers</strong></h3>
						<p class="subtext">Taxes fees and carrier changes included</p>
					</div>
					<p><strong>{{TAP_printTotal()}}</strong></p>
				</li>
			</ul>
		</div>
		<div class="sidebar-flight-text">
			<button class="button " (click)="TAP_handleClose()" aria-label="Add more extras.">Add more extras</button>
			<button class="button button-accent button--mobile-full" (click)="goToPayment()"
				aria-label="Continue to payment.">Continue to
				payment</button>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer">
	</div>
</div>
